import script from "./UpdateBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateBanner.vue?vue&type=script&setup=true&lang=js"

import "./UpdateBanner.vue?vue&type=style&index=0&id=ffaa3f64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffaa3f64"]])

export default __exports__